import { useEffect, useState } from 'react';

import { CloudProviders } from '@ariksa/cloud-account';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useDeepCompareEffect, useLocation } from 'react-use';

import { selectApp } from 'containers/App/selectors';

import { UserPermission } from './UserPermission';
import { PermissionConfig } from './UserPermissionConfig';

export function useUserPermission() {
  const navigate = useNavigate();
  const { pathname = '/', hostname } = useLocation();
  const { userAuth, accessBoundary, user } = useSelector(selectApp);
  const [userPermission, setUserPermission] = useState<UserPermission>(
    new UserPermission(),
  );
  const { type, environment, account } = accessBoundary;

  useEffect(() => {
    setUserPermission(
      new UserPermission(
        [],
        PermissionConfig(
          type === 'Account'
            ? [account?.cloud_type!?.toUpperCase()]
            : environment?.cloud_providers ?? [],
          user?.info?.org_id,
          hostname,
        ),
      ),
    );
  }, [type, environment, account, user.info, hostname]);

  useEffect(() => {
    if (
      ((type === 'Account' && account?.cloud_type === CloudProviders.Azure) ||
        (type === 'Environment' &&
          environment?.cloud_providers?.length === 1 &&
          environment?.cloud_providers?.[0] === 'AZURE')) &&
      pathname === '/dashboard/identity'
    ) {
      navigate('/dashboard');
    } else if (pathname !== '/' && !userPermission?.includesPath(pathname)) {
      const subPath = pathname.split('/').slice(0, -1).join('/');
      const newPath = userPermission?.firstIncludedPath(subPath);
      console.log('newPath', newPath, pathname, subPath);
      if (pathname !== newPath) {
        console.log('Redirecting to: ', newPath);
        // history.replace(newPath);
        //navigate(subPath);
      }
    }
  }, [navigate, pathname, userPermission, type, environment]);

  // console.log('userAuth', userAuth);
  useDeepCompareEffect(() => {
    if (!userPermission.isSameRoles(userAuth.data.roles ?? [])) {
      if (userAuth.data.roles?.length) {
        const permission = new UserPermission(
          userAuth.data.roles,
          PermissionConfig(
            type === 'Account'
              ? [account?.cloud_type!?.toUpperCase()]
              : environment?.cloud_providers ?? [],
            user?.info?.org_id,
            hostname,
          ),
        );
        setUserPermission(permission);

        // @ts-ignore
        window.up = permission;
      }
    }
  }, [userPermission, userAuth.data.roles]);

  const resetUserPermission = () => {
    setUserPermission(UserPermission.default());
  };

  return { userPermission, resetUserPermission };
}
